import { GetChannels } from '@/core';
import { benchmarksMutationTypes } from '../mutation-types';

export async function getChannels({ commit, state }) {
  if (!state.channels.length) {
    const { channelList } = await GetChannels.execute();

    commit(benchmarksMutationTypes.ADD_CHANNEL_LIST, channelList);
  }
}
